module.exports = __webpack_public_path__ + "static/wpack/extracted/circled-heart804b223054f81c11261dc8bdc994e027.svg";